import { createSlice } from '@reduxjs/toolkit';
import { NotificationRes } from '@DStypes/notifications';

const initialState: NotificationRes = {
  allMessages: [],
  unreadMessages: [],
  userMessages: [],
  storedUserMessages: [],
  isInitialLoad: true
};

export const notificationsData = createSlice({
  name: 'notificationsData',
  initialState,
  reducers: {
    setStoreNotifications: (state, { payload }) =>
      ({
        ...state,
        allMessages: payload?.allMessages,
        unreadMessages: payload?.unreadMessages
      } || {}),
    setInitialLoad: (state) =>
      ({
        ...state,
        isInitialLoad: false
      } || {}),
    setUserNotifications: (state, { payload }) => {
      const userMessages = [...(state.userMessages || [])];

      userMessages.push(payload);

      return { ...state, userMessages } || [];
    },
    setStoredUserNotifications: (state, { payload }) =>
      ({
        ...state,
        storedUserMessages: payload
      } || {}),
    markUserMessageAsRead: (state, { payload }) => {
      const { notificationsData, message_id } = payload;
      const unreadMessages = [...(notificationsData.unreadMessages || [])];
      const userMessages = [...(notificationsData.userMessages || [])];

      const unreadMsgIndex = unreadMessages.findIndex(
        (msg) => msg.id === message_id
      );
      const userMsgIndex = userMessages.findIndex(
        (msg) => msg.id === message_id
      );

      unreadMessages.splice(unreadMsgIndex, 1);
      const updatedMessage = { ...userMessages[userMsgIndex], is_read: true };

      userMessages.splice(userMsgIndex, 1, updatedMessage);

      return { ...notificationsData, unreadMessages, userMessages };
    },
    markAllUserMessageAsRead: (state, { payload }) => {
      const { notificationsData } = payload;
      const unreadMessages = notificationsData.unreadMessages.map(
        (msg: any) => ({ ...msg, is_read: true })
      );
      const userMessages = notificationsData.userMessages.map((msg: any) => ({
        ...msg,
        is_read: true
      }));

      return { ...notificationsData, unreadMessages, userMessages };
    }
  }
});

export const {
  setStoreNotifications,
  setUserNotifications,
  markUserMessageAsRead,
  setStoredUserNotifications,
  setInitialLoad,
  markAllUserMessageAsRead
} = notificationsData.actions;

export default notificationsData.reducer;
